import { RadioGroup, Box } from '@mui/material';
import { ChangeEvent } from 'react';
import { RadioButton } from './RadioButton';
import { TextWrapper, TextWrapperProps } from './TextWrapper';
import ConditionalWrapper from '../wrappers/ConditionalWrapper';
import { theme } from '../../configs/theme';

type button = {
  title: string;
  value: string;
  isDisabled?: boolean;
};

type Props = {
  radioButtons: button[];
  groupValue: string;
  onChange: (value: ChangeEvent<HTMLInputElement>) => void;
  name: string;
  /**
   * If true, displays a red asterisk (*) next to the label to indicate a required field.
   */
  required?: boolean;
  /**
   * Is there an error in the input field?
   */
  error?: boolean;
  /**
   * Text to display below if error.
   */
  errorText?: string;
  wrapperProps?: Omit<TextWrapperProps, 'children'>;
};

export const RadioButtonGroup = ({
  groupValue,
  onChange,
  radioButtons,
  name,
  required,
  error,
  errorText,
  wrapperProps,
}: Props) => {
  return (
    <ConditionalWrapper
      condition={!!wrapperProps}
      wrapper={(children) => (
        <TextWrapper sx={{ width: '100%' }} {...wrapperProps} required={required}>
          {children}
        </TextWrapper>
      )}
    >
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <RadioGroup name={name} row value={groupValue} onChange={onChange}>
          {radioButtons.map((button, index) => (
            <RadioButton
              key={index}
              isDisabled={button.isDisabled}
              title={button.title}
              value={button.value}
            />
          ))}
        </RadioGroup>
        {error && (
          <p style={{ color: theme.palette.status.rejected, fontSize: '12px', margin: 0 }}>
            {errorText}
          </p>
        )}
      </Box>
    </ConditionalWrapper>
  );
};
